import {createAction} from 'redux-actions';

export const setSelectedSite = createAction('SET_SELECTED_SITE');

export const dropSelectedSite = createAction('DROP_SELECTED_SITE');
